module.exports = __webpack_public_path__ + "/login_ui/img/bw-4243649971abe3d8723a0f4da0482708.svg";